import type { FaireProductEntity } from "../../entity_types/product";

export const p_cr368x8tss: FaireProductEntity = {
  token: "p_cr368x8tss",
  type: "product",
  name: "Counter POP Display - Countertop Cardboard Display",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/d543912b6bb422237e568f08e42419df1b59449de360447be12196d4fd9c41f4.jpeg",
  galleryImageUrls: [],
  priceDollars: 0.01,
  description: "(Limit: 2 displays per store location)\n\nA great new way to showcase your Gumball Poodle socks!\n\nIntroducing our 4-pocket cardboard counter display!\nFREE with a minimum order of 24 pairs of socks, any styles of your choice. You pick the socks you love!\n\n•Holds up to 4 different styles, and 24 pairs.\n•Features a compact footprint, that holds a total suggested retail value of $336.\n•Comes assembled with easy-to-attach header.\n•Made of sturdy cardboard right here in the USA.\n\nFREE with minimum purchase of 24 pairs of socks\n\nMeasures: 17\" wide, 10\" tall, 11.5\" deep\n\nPlace on a counter, a table, a shelf–anywhere Gumball Poodle socks will shine!\n\n(Limit: 2 displays per store location)",
  tags: [],
  msrpDollars: 0.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:57.002Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
